//
//
//
//
//
//
//

import { getContent } from '~/assets/js/connector/content.js'
import ConnectorLanding from '~/components/connector/ConnectorLanding.vue'
import ConnectorDashboard from '~/components/connector/ConnectorDashboard.vue'

export default {
  name: 'ConnectorPage',
  components: { ConnectorLanding, ConnectorDashboard },
  // 阻止子组件错误传递给 Nuxt 全局处理器（防止意外跳转到 404 页面）
  errorCaptured () {
    return false
  },
  computed: {
    isLoggedIn () {
      return !!this.$store.state.simpleUser?.userId
    },
    userId () {
      return this.$store.state.simpleUser?.userId || ''
    },
    content () {
      return getContent(this.currLangCode())
    }
  },
  head () {
    return {
      title: this.$t('83908'),
      meta: [
        { hid: 'description', name: 'description', content: this.content.heroSubtitle }
      ],
      link: this.setCanonical()
    }
  },
  watch: {
    // 语言切换时内容自动更新（computed 已响应，此处无需额外处理）
    '$store.state.locale' () {}
  }
}
